import ARENO_API_ENDPOINT from "../../api";

const ResellerServices = {
  // Add new reseller
  addReseller: async (token, resellerData) => {
    try {
      const response = await fetch(
        `${ARENO_API_ENDPOINT}/auth/AdminOnboardReseller`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(resellerData),
        }
      );

      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Get all reseller list
  getAllResellerList: async (token) => {
    try {
      const response = await fetch(
        `${ARENO_API_ENDPOINT}/auth/AdminGetAllResellerList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({}),
        }
      );

      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Update reseller details
  updateResellerDetails: async (token, updateData) => {
    try {
      const response = await fetch(
        `${ARENO_API_ENDPOINT}/auth/AdminUpdateResellerDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updateData),
        }
      );

      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Get reseller list
  adminGetAllResellerList: async (token, navigate) => {
    try {
      let response = await fetch(
        `${ARENO_API_ENDPOINT}/auth/AdminGetAllResellerList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: {},
        }
      );

      response = await response.json();
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  },
};

export default ResellerServices;
